/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';
    var app = angular.module('enervee');

    app.directive('mobileNav', [function() {
        return {
            restrict: 'E',
            scope: {},
            controller: [
                '$scope',
                '$timeout',
                'AccountAuthService',
                'AccountService',
                'HeaderService',
                'IndexService',
                'MobileMenuService',
                'UtilService',
                function (
                    $scope,
                    $timeout,
                    AccountAuthService,
                    AccountService,
                    HeaderService,
                    IndexService,
                    MobileMenuService,
                    UtilService
                ) {
                    $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
                    $scope.rebateFastTrackEnabled = UtilService.isFeatureEnabled('rebate_fast_track')
                        || UtilService.getSiteSetting('rebate_fast_track_url')
                        || UtilService.isFeatureEnabled('fast_track_with_rrapi');
                    $scope.trackNavEngagement = MobileMenuService.trackNavEngagement;

                    $scope.signIn = function() {
                        HeaderService.signIn();
                    };

                    AccountAuthService.onEveryAuthChange('updateMobileNav', function () {
                        $scope.isLoggedInResponse = AccountAuthService.isLoggedInResponse;
                    });

                    $scope.closeMobileNav = MobileMenuService.closeMobileNav;
                }],
            template: require('@app/shared/mobileNav/mobileNav.html'),
        };

    }]);

})(angular);
